import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";
import { hideLoader, showLoader } from "./loaderSlice";
import { showSnackBar } from "./snackSlice";

export const getSupportTickets = createAsyncThunk(
  "getSupportTickets",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/support/tickets`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? res?.data ?? [];
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message:
            err?.response?.data?.message || "Failed to load support tickets",
          type: "error",
        }),
      );
      return false;
    }
  },
);

export const createSupportTicket = createAsyncThunk(
  "createSupportTicket",
  async (form, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/support/ticket`, form);
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Support ticket created",
            type: "success",
          }),
        );
        return res?.data?.data ?? true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: res?.data?.message || "Failed to create support ticket",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message:
            err?.response?.data?.message || "Failed to create support ticket",
          type: "error",
        }),
      );
      return false;
    }
  },
);

const supportSlice = createSlice({
  name: "support",
  initialState: {
    tickets: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSupportTickets.fulfilled, (state, action) => {
      if (action.payload) {
        state.tickets = Array.isArray(action.payload) ? action.payload : [];
      }
    });
  },
});

export default supportSlice.reducer;
